<section class="page-stack">
  <div class="page-heading">
    <div>
      <span class="eyebrow">ISO8583</span>
      <h2>Transacciones ISO</h2>
    </div>
    <button class="primary-button" type="button" [disabled]="loading" (click)="load()">Actualizar</button>
  </div>

  <form class="panel filter-panel" (ngSubmit)="applyFilters()">
    <div class="panel-header">
      <div>
        <span class="eyebrow">Filtros</span>
        <h3>Busqueda avanzada</h3>
      </div>
      <div class="header-actions">
        <button class="ghost-button" type="button" [disabled]="loading" (click)="clearFilters()">Limpiar</button>
        <button
          class="icon-button collapse-button"
          type="button"
          (click)="filtersOpen = !filtersOpen"
          [attr.aria-expanded]="filtersOpen"
          aria-controls="isoFilters">
          {{ filtersOpen ? '⌃' : '⌄' }}
        </button>
      </div>
    </div>

    <div id="isoFilters" class="collapsible" [class.open]="filtersOpen">
    <div class="filter-grid">
      <label>ID <input type="number" name="id" [(ngModel)]="filters['id']"></label>
      <label>Reference Number <input name="referenceNumber" [(ngModel)]="filters['referenceNumber']"></label>
      <label>Terminal <input name="terminalIdentification" [(ngModel)]="filters['terminalIdentification']"></label>
      <label>Autorizacion <input name="authorizationCode" [(ngModel)]="filters['authorizationCode']"></label>
      <label>BIN <input name="bin" [(ngModel)]="filters['bin']"></label>
      <label>Ultimos 4 <input name="l4d" [(ngModel)]="filters['l4d']"></label>
      <label>STAN <input name="stan" [(ngModel)]="filters['stan']"></label>
      <label>Monto desde <input type="number" name="amountMin" [(ngModel)]="filters['amountMin']"></label>
      <label>Monto hasta <input type="number" name="amountMax" [(ngModel)]="filters['amountMax']"></label>
      <label>Fecha desde <input type="date" name="dateFrom" [(ngModel)]="filters['dateFrom']"></label>
      <label>Fecha hasta <input type="date" name="dateTo" [(ngModel)]="filters['dateTo']"></label>
      <label>Estado
        <select name="transactionStatus" multiple [(ngModel)]="filters['transactionStatus']">
          <option *ngFor="let item of statuses" [value]="item.value">{{ item.label }}</option>
        </select>
      </label>
      <label>Entry Mode
        <select name="posEntryModeType" multiple [(ngModel)]="filters['posEntryModeType']">
          <option *ngFor="let item of entryModes" [value]="item.value">{{ item.label }}</option>
        </select>
      </label>
      <label>Processing Code
        <select name="processingCodeType" multiple [(ngModel)]="filters['processingCodeType']">
          <option *ngFor="let item of processingCodes" [value]="item.value">{{ item.label }}</option>
        </select>
      </label>
      <label>Marca
        <select name="brand" multiple [(ngModel)]="filters['brand']">
          <option *ngFor="let item of brands" [value]="item">{{ item }}</option>
        </select>
      </label>
    </div>

    <div class="table-actions">
      <button class="primary-button" type="submit" [disabled]="loading">Buscar</button>
    </div>
    </div>
  </form>

  <div class="panel">
    <div class="panel-header">
      <div>
        <span class="eyebrow">{{ total }} registros</span>
        <h3>Listado ISO8583</h3>
      </div>
      <label class="inline-control">Filas
        <select name="size" [(ngModel)]="size" [disabled]="loading" (ngModelChange)="page = 0; load()">
          <option *ngFor="let option of pageSizes" [value]="option">{{ option }}</option>
        </select>
      </label>
    </div>

    <div class="state error" *ngIf="error">{{ error }}</div>
    <div class="state" *ngIf="loading">Cargando transacciones ISO...</div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th><th>Reference</th><th>Terminal</th><th>STAN</th><th>Fecha</th><th>Monto</th>
            <th>Marca</th><th>Processing</th><th>EntryMode</th><th>Status</th><th>BIN</th><th>4LD</th><th>Auth</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td>{{ row.id }}</td>
            <td>{{ text(row.referenceNumber) }}</td>
            <td>{{ text(row.terminalIdentification) }}</td>
            <td>{{ text(row.stan) }}</td>
            <td>{{ dateTime(row.localTransactionDateTime) }}</td>
            <td>{{ moneyFromCents(row.amountTransaction) }}</td>
            <td><img class="brand-logo" [src]="brandImage(row.brand)" alt="" onerror="this.src='/img/brands/unknown.png'"></td>
            <td>{{ text(row.processingCodeType) }}</td>
            <td>{{ text(row.posEntryModeType) }}</td>
            <td><span [class]="statusClass(row.transactionStatus)">{{ text(row.transactionStatus) }}</span></td>
            <td>{{ text(row.bin) }}</td>
            <td>{{ text(row.l4d) }}</td>
            <td>{{ text(row.authorizationCode) }}</td>
            <td><button class="icon-button" type="button" (click)="openDetail(row.id)">Ver</button></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <span class="pagination-status">
        <span class="loading-spinner" *ngIf="loading" aria-hidden="true"></span>
        Pagina {{ page + 1 }} de {{ totalPages }}
      </span>
      <div class="pagination-actions">
        <button class="ghost-button" type="button" [disabled]="loading || page === 0" (click)="changePage(-1)">Anterior</button>
        <div class="page-buttons" aria-label="Paginas">
          <ng-container *ngFor="let item of visiblePages()">
            <span class="page-ellipsis" *ngIf="item === 'ellipsis'">...</span>
            <button
              *ngIf="item !== 'ellipsis'"
              class="page-button"
              type="button"
              [disabled]="loading"
              [class.active]="page === item"
              [attr.aria-current]="page === item ? 'page' : null"
              (click)="goToPage(item)">
              {{ item + 1 }}
            </button>
          </ng-container>
        </div>
        <button class="ghost-button" type="button" [disabled]="loading || page + 1 >= totalPages" (click)="changePage(1)">Siguiente</button>
      </div>
    </div>
  </div>
</section>

<div class="modal-backdrop" *ngIf="detail || detailLoading" (click)="closeDetail()">
  <article class="modal transaction-detail-modal" (click)="$event.stopPropagation()">
    <header class="detail-header">
      <div>
        <span class="eyebrow">Detalle ISO8583</span>
        <h3>#{{ text(detailValue('id')) }} · {{ text(detailValue('transactionId')) }}</h3>
      </div>
      <button class="icon-button" type="button" (click)="closeDetail()">Cerrar</button>
    </header>

    <div class="state loading-state" *ngIf="detailLoading">
      <span class="loading-spinner" aria-hidden="true"></span>
      Cargando detalle...
    </div>

    <ng-container *ngIf="detail">
      <div class="detail-summary">
        <div>
          <span>Estado</span>
          <strong [class]="statusClass(detailValue('transactionStatus'))">
            {{ text(detailValue('transactionStatus')) }}
          </strong>
        </div>
        <div>
          <span>Monto</span>
          <strong>{{ formatDetailValue('amountTransaction') }}</strong>
        </div>
        <div>
          <span>Fecha</span>
          <strong>{{ formatDetailValue('localTransactionDateTime') }}</strong>
        </div>
        <div>
          <span>Terminal</span>
          <strong>{{ text(detailValue('terminalData.terminalIdentification')) }}</strong>
        </div>
      </div>

      <nav class="detail-tabs" aria-label="Secciones del detalle ISO">
        <button
          *ngFor="let tab of detailTabs"
          type="button"
          class="detail-tab"
          [class.active]="activeDetailTab === tab.id"
          (click)="activeDetailTab = tab.id">
          <span class="detail-tab-icon"><ng-icon [name]="detailIcon(tab.icon)" /></span>
          {{ tab.label }}
        </button>
      </nav>

      <div class="detail-grid compact">
        <div class="detail-item" *ngFor="let item of activeDetailItems()">
          <span class="detail-icon"><ng-icon [name]="detailIcon(item.icon)" /></span>
          <div>
            <span>{{ item.label }}</span>
            <strong>{{ formatDetailValue(item.key) }}</strong>
          </div>
        </div>
      </div>

      <div class="state" *ngIf="activeDetailItems().length === 0">Sin datos para esta seccion.</div>
    </ng-container>
  </article>
</div>
